import React from 'react';
import styled from 'styled-components';
import {
	JobCountLabel,
	RefreshButton,
	SpinningRefreshIcon,
	Toolbar,
	ToolbarSpacer,
} from '@warehouse/object-browser/feature-broker';
import { Chip, Tooltip } from '@warehouse/shared/legacy-ui';
import { SERVICE_LOG_STATUS_QUICK_FILTERS } from '@warehouse/service-log/core';
import { serviceLogStoreSelector, useServiceLogStore } from '@warehouse/service-log/domain';

const QuickFilters = styled('div')(({ theme }) => ({
	display: 'flex',
	flexWrap: 'wrap',
	gap: theme.spacing(0.75),
}));

/** Same toolbar as the Logs tab (count + refresh) plus the status quick filters. */
export function ServiceLogToolbar() {
	const totalJobs = useServiceLogStore(serviceLogStoreSelector.totalJobs);
	const isRefreshing = useServiceLogStore(serviceLogStoreSelector.isRefreshing);
	const statusQuickFilter = useServiceLogStore(serviceLogStoreSelector.statusQuickFilter);
	const { refresh, setStatusQuickFilter } = useServiceLogStore(serviceLogStoreSelector.actions);

	return (
		<Toolbar>
			<JobCountLabel>{totalJobs === 1 ? '1 job' : `${totalJobs.toLocaleString()} jobs`}</JobCountLabel>
			<ToolbarSpacer />
			<QuickFilters role="group" aria-label="Status quick filters">
				{SERVICE_LOG_STATUS_QUICK_FILTERS.map(({ value, label }) => (
					<Chip
						key={value}
						label={label}
						clickable
						withHover
						variant={statusQuickFilter === value ? 'prefilled' : 'default'}
						aria-pressed={statusQuickFilter === value}
						onClick={() => setStatusQuickFilter(value)}
					/>
				))}
			</QuickFilters>
			<Tooltip title="Refresh">
				<RefreshButton type="button" nxstyle="normal" aria-label="Refresh-Button" onClick={() => refresh()}>
					<SpinningRefreshIcon $spinning={isRefreshing} fontSize="small" />
				</RefreshButton>
			</Tooltip>
		</Toolbar>
	);
}
